module.exports = __webpack_public_path__ + "img/maps3.9ba96105.jpg";